import { N0 } from '@atlaskit/theme/colors';
import React from 'react';
import { chartLineStyles } from '../../Common/ChartUtils';
import ReportSummaryOverview from '../../Common/ReportSummaryOverview';
import { chartLineColors, reasonKeyToContent } from '../FeedbackReports.constants';
import { getReportColumnsForSeries } from '../FeedbackReports.utils';
import { getAppsWidth, headerConfigByFilter } from '../FeedbackReportsHead';
export default function FeedbackSummary(props) {
  const {
    totalSeries,
    reportBy,
    source,
    reportName,
    period,
    reasonKeyConfigState,
    enableReportsAccessibilityChanges
  } = props;
  const reportMeta = {
    reportName,
    period
  };
  const reportColumns = getReportColumnsForSeries(totalSeries, reportBy, source, true);
  const allAppsWidth = getAppsWidth(reportBy);
  const summary = [];
  const headersConfig = headerConfigByFilter[reportBy] || headerConfigByFilter[source];
  headersConfig.map((reasonKey, index) => {
    const color = reasonKeyConfigState.has(reasonKey) ? chartLineStyles[index].color : "var(--ds-background-neutral-subtle, rgba(255, 255, 255, 0))";
    summary.push({
      head: reasonKeyToContent[reasonKey].name,
      color: enableReportsAccessibilityChanges ? color : chartLineColors[index].color,
      content: reportColumns[index].content,
      width: "".concat((100 - allAppsWidth) / reportColumns.length, "%")
    });
  });
  summary.push({
    head: "All ".concat(reportName),
    color: N0,
    content: reportColumns[reportColumns.length - 1].content,
    width: "".concat((100 - allAppsWidth) / reportColumns.length, "%")
  });
  return /*#__PURE__*/React.createElement(ReportSummaryOverview, {
    summary: summary,
    reportMeta: reportMeta
  });
}